import { Chip, Tooltip } from "@mui/material";

export const actionTypesCodes = [
	{ Code: "A", Name: "All", Color: "#888888ff" },
	{ Code: "C", Name: "Create", Color: "#FDBA74" },
	{ Code: "S", Name: "Swap", Color: "#FCA5A5" },
	{ Code: "M", Name: "Mix", Color: "#DDD6FE" },
];

type ActionTypesTagProps = {
	code: String;
	showName?: boolean;
};

export const ActionTypeTag = ({
	code,
	showName = false,
}: ActionTypesTagProps) => {
	if (!code) {
		return null;
	}

	const actionType = actionTypesCodes.find((lt) => lt.Code === code);
	const backgroundColor = actionType?.Color;

	return (
		<Tooltip title={actionType?.Name} arrow>
			<Chip
				label={showName ? actionType?.Name : actionType?.Code}
				size="small"
				sx={{
					backgroundColor,
					color: "white",
					fontWeight: 600,
					fontSize: "0.7rem",
					height: 22,
					borderRadius: 1,
				}}
			/>
		</Tooltip>
	);
};
